import React, { ReactNode, useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { Bold } from '@styles/generalStyles';

interface IUseOrderLimitNotificationProps {
  orderLimitReachedMaxValueMessage: MessageDescriptor;
  orderLimitReachedNextPurchaseAdviceMessage: MessageDescriptor;
  orderLimitReachedHeader: MessageDescriptor;
}

interface IOrderLimitNotificationMessages {
  header: ReactNode;
  messages: ReactNode[];
}

export const useOrderLimitNotificationModal = (
  messages: IUseOrderLimitNotificationProps,
): IOrderLimitNotificationMessages => {
  const {
    applicationSettings: {
      shopSettings: { orderLimit },
      primaryCurrency: { currency },
    },
  } = useApplicationRuntimeContext();
  const { formatMessage } = useIntl();

  return useMemo(
    () => ({
      header: formatMessage(messages.orderLimitReachedHeader),
      messages: [
        formatMessage(messages.orderLimitReachedMaxValueMessage, {
          b: (...chunks: ReactNode[]) => <Bold>{chunks}</Bold>,
          value: orderLimit,
          currency: currency,
        }),
        formatMessage(messages.orderLimitReachedNextPurchaseAdviceMessage),
      ],
    }),
    [formatMessage, orderLimit, currency, messages],
  );
};
